module.exports = __webpack_public_path__ + "static/google-play-badge-tr-08c5d83ddf3b620ad69c7c2f515cd49a.png";